<template>
  <div class="step-wrapup">
    <h2>Final Questions</h2>
    <div class="wrapup-form">
      <div class="question-block">
        <label>Based on this experience, how likely would you be to use Astro Way again?</label>
        <div class="num-row">
          <button v-for="n in 11" :key="n-1" class="num-btn" :class="{ active: likelyToUse === n-1 }" @click="likelyToUse = n-1">{{ n-1 }}</button>
        </div>
        <div class="num-labels"><span>Not at all</span><span>Extremely</span></div>
      </div>
      <div class="question-block">
        <label>How much did these answers feel like they came from a real astrologer rather than a generic AI?</label>
        <div class="num-row">
          <button v-for="n in 11" :key="n-1" class="num-btn" :class="{ active: realAstrologer === n-1 }" @click="realAstrologer = n-1">{{ n-1 }}</button>
        </div>
        <div class="num-labels"><span>Not at all</span><span>Extremely</span></div>
      </div>
      <div class="question-block">
        <label>If this experience were inside the Astro Way mobile app, how likely would you be to pay for a subscription?</label>
        <div class="num-row">
          <button v-for="n in 11" :key="n-1" class="num-btn" :class="{ active: likelyToPay === n-1 }" @click="likelyToPay = n-1">{{ n-1 }}</button>
        </div>
        <div class="num-labels"><span>Not at all</span><span>Extremely</span></div>
      </div>
      <div class="question-block">
        <label>What was the strongest part of the experience?</label>
        <textarea v-model="strongest" rows="3" placeholder="Your answer..."></textarea>
      </div>
      <div class="question-block">
        <label>What was the weakest part of the experience?</label>
        <textarea v-model="weakest" rows="3" placeholder="Your answer..."></textarea>
      </div>
      <p v-if="showError" class="validation-error">Please answer all questions before submitting.</p>
      <button class="primary-btn" @click="submit" :disabled="submitting">
        {{ submitting ? 'Submitting...' : 'Finish Test' }}
      </button>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
export default {
  name: 'StepWrapUp',
  emits: ['submit'],
  setup(_, { emit }) {
    const likelyToUse = ref(null)
    const realAstrologer = ref(null)
    const likelyToPay = ref(null)
    const strongest = ref('')
    const weakest = ref('')
    const submitting = ref(false)
    const showError = ref(false)

    const submit = () => {
      if (likelyToUse.value === null || realAstrologer.value === null || likelyToPay.value === null || !strongest.value.trim() || !weakest.value.trim()) {
        showError.value = true
        return
      }
      showError.value = false
      submitting.value = true
      emit('submit', {
        likelyToUse: likelyToUse.value,
        realAstrologer: realAstrologer.value,
        likelyToPay: likelyToPay.value,
        strongest: strongest.value,
        weakest: weakest.value
      })
    }

    return { likelyToUse, realAstrologer, likelyToPay, strongest, weakest, submitting, showError, submit }
  }
}
</script>

<style scoped>
.step-wrapup { max-width: 560px; margin: 0 auto; padding: 20px; text-align: center; }
.step-wrapup h2 { font-size: 24px; font-weight: 700; color: #fff; margin-bottom: 28px; text-align: center; }
.wrapup-form { display: flex; flex-direction: column; gap: 24px; }
.question-block { display: flex; flex-direction: column; gap: 8px; }
.question-block label { font-size: 15px; color: rgba(255,255,255,0.8); font-weight: 500; line-height: 1.5; }
.num-row { display: flex; gap: 6px; }
.num-btn { width: 40px; height: 40px; border-radius: 10px; border: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.04); color: rgba(255,255,255,0.5); font-size: 15px; font-weight: 600; cursor: pointer; transition: all 0.15s; font-family: inherit; }
.num-btn:hover { background: rgba(108,99,255,0.1); }
.num-btn.active { background: #6c5ce7; border-color: #6c5ce7; color: #fff; transform: scale(1.1); }
.num-labels { display: flex; justify-content: space-between; font-size: 11px; color: rgba(255,255,255,0.3); margin-top: 4px; }
.question-block textarea { padding: 14px 18px; background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.15); border-radius: 14px; color: #fff; font-size: 15px; resize: vertical; font-family: inherit; text-align: left; }
.question-block textarea::placeholder { color: rgba(255,255,255,0.3); }
.question-block textarea:focus { outline: none; border-color: rgba(255,255,255,0.3); }
.primary-btn { padding: 16px 24px; background: #6c5ce7; border: none; border-radius: 12px; color: #fff; font-size: 16px; font-weight: 600; cursor: pointer; transition: all 0.2s; margin-top: 8px; }
.primary-btn:disabled { opacity: 0.4; cursor: not-allowed; }
.primary-btn:hover:not(:disabled) { background: #7c6ff0; box-shadow: 0 6px 20px rgba(108,99,255,0.35); }
.validation-error { font-size: 13px; color: #f87171; margin: 0; }
</style>
